import { Button } from '@material-ui/core';

import { usePhoneCallBtn } from './hooks';

import makeClasses from './PhoneCallBtn.styles';

export function PhoneCallBtn() {
  const { lang, handleOnClick } = usePhoneCallBtn();

  const _classes = makeClasses();

  return (
    <Button
      fullWidth
      variant='outlined'
      onClick={handleOnClick}
      className={_classes.btn}
    >
      {lang.callUser}
    </Button>
  );
}
